<div class="page center">
  <div class="login-card">
    <div class="eyebrow" style="float: right;">VisitoCare</div>
    <div style="margin-top: 40px;">
      <h2>Create new password</h2>

      <label style="margin-top: 20px;">New password</label>
      <input [(ngModel)]="password" type="password">

      <label>Confirm password</label>
      <input [(ngModel)]="confirmPassword" type="password">

      <button (click)="reset()" style="margin-top:12px;">Reset password</button>

      <div style="float: right; margin-top:20px;">
      <div class="error" *ngIf="error">{{ error }}</div>
      <div class="small" *ngIf="message">{{ message }}</div>
    </div>
    <div class="small" style="margin-left:5px; margin-top: 20px;"><a class="link" routerLink="/login">Back to login</a></div>
    
  </div>
  </div>
</div>